CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
Organization = require 'models/organization'

module.exports = class OrganizationList extends CollectionWithHelpers
  model: Organization
  initialize: ->
    @listenTo @, 'change:name', @sort
    return

  comparator: (organization) -> organization.get('name')?.toUpperCase() || ""



// WEBPACK FOOTER //
// ./app/scripts/models/collections/organization-list.coffee